module.exports = __webpack_public_path__ + "8e573dbe1c8722f2f616934f442b4150.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/cover/schneefeld.jpg
// module id = 136
// module chunks = 0